import { defineStore } from 'pinia';
import { recentListingStatus } from '../_config';
import getters from './getters';
import actions from './actions';
function initState() {
    return {
        listingStatus: [], // listing status  the list 
        listing: [], // listing  listings 
        //  real estate recent listing The state the module is in 
        fetchListingStatus: recentListingStatus.coming,
        currentListingStatus: '', //  currently selected listingStatus
        currentListingStatusName: '', //  currently selected listingStatus of name value ， for display 
        searchParams: {}, // search condition
        hasLocation: false,
        //  pagination parameters 
        totalPage: 0,
        pageSize: 5,
        pageNum: 1,
        showListingPrice: true,
        // showSoldPrice: true,   Do you need to display sold listing price
        hasFetchListingStatus: false,
        soldListingInfo: null, //  Sold listing information 
        showThisModule: true //  whether to show the module ， current ： If on the sold details page   and city/zipCode Is empty   then hide the module 
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    getters,
    actions
});
